import { useMemo } from "react";
import countryList from "react-select-country-list";

type optionsType = {
  value: string;
  label: string;
}[];

export default function useSupportedCountries() {
  const UNSUPPORTED_COUNTRIES = [
    "AF", // Afghanistan
    "AL", // Albania
    "DZ", // Algeria
    "AO", // Angola
    "AI", // Anguilla
    "AG", // Antigua & Barbuda
    "AZ", // Azerbaijan
    "BS", // Bahamas
    "BD", // Bangladesh
    "BB", // Barbados
    "BY", // Belarus
    "BA", // Bosnia & Herzegovina
    "BG", // Bulgaria
    "BF", // Burkina Faso
    "KH", // Cambodia
    "CM", // Cameroon
    "TD", // Chad
    "CF", // Central African Republic
    "CN", // China
    "KM", // Comoros
    "CG", // Congo
    "CD", // Democratic Republic of the Congo
    "CI", // Côte d'Ivoire
    "HR", // Croatia
    "CU", // Cuba
    "GQ", // Equatorial Guinea
    "ER", // Eritrea
    "ET", // Ethiopia
    "GH", // Ghana
    "GI", // Gibraltar
    "GT", // Guatemala
    "GU", // Guam
    "GW", // Guinea-Bissau
    "GY", // Guyana
    "HT", // Haiti
    "HN", // Honduras
    "IN", // India
    "IR", // Iran
    "IQ", // Iraq
    "JM", // Jamaica
    "JP", // Japan
    "JO", // Jordan
    "KE", // Kenya
    "KP", // North Korea
    "KW", // Kuwait
    "LA", // Laos
    "LB", // Lebanon
    "LY", // Libya
    "ML", // Mali
    "MA", // Morocco
    "MX", // Mexico
    "MC", // Monaco
    "MN", // Mongolia
    "MZ", // Mozambique
    "MM", // Myanmar
    "NA", // Namibia
    "NP", // Nepal
    "NG", // Nigeria
    "NI", // Nicaragua
    "NE", // Niger
    "PK", // Pakistan
    "PA", // Panama
    "PH", // Philippines
    "QA", // Qatar
    "RU", // Russia
    "KN", // Saint Kitts and Nevis
    "SN", // Senegal
    "SL", // Sierra Leone
    "SO", // Somalia
    "ZA", // South Africa
    "SS", // South Sudan
    "SD", // Sudan
    "SY", // Syria
    "LK", // Sri Lanka
    "TJ", // Tajikistan
    "TW", // Taiwan
    "TZ", // Tanzania
    "TH", // Thailand
    "TT", // Trinidad & Tobago
    "TN", // Tunisia
    "TR", // Turkey
    "TM", // Turkmenistan
    "UA", // Ukraine
    "UG", // Uganda
    "AE", // UAE
    "VI", // Virgin Islands
    "VU", // Vanuatu
    "CA", // Canada
    "KY", // Cayman Islands
    "VE", // Venezuela
    "VN", // Vietnam
    "YE", // Yemen
    "ZW", // Zimbabwe
  ];
  const allCountries: optionsType = useMemo(() => countryList().getData(), []);

  let supportedCountries = allCountries.filter((country) => {
    // return !UNSUPPORTED_COUNTRIES.find((unsupported) => unsupported === country.value);
    return ["AU", "NZ", "US", "GB"].includes(country.value);
  });

  let westernCountries = ["US", "GB", "AU"]; // More country codes can be added

  supportedCountries.sort((a, b) => {
    let aIsWestern = westernCountries.includes(a.value);
    let bIsWestern = westernCountries.includes(b.value);

    if (aIsWestern && !bIsWestern) {
      return -1;
    }
    if (!aIsWestern && bIsWestern) {
      return 1;
    }
    return 0;
  });

  allCountries.sort((a, b) => {
    let aIsWestern = westernCountries.includes(a.value);
    let bIsWestern = westernCountries.includes(b.value);

    if (aIsWestern && !bIsWestern) {
      return -1;
    }
    if (!aIsWestern && bIsWestern) {
      return 1;
    }
    return 0;
  });

  function isCountrySupported(countryName: string) {
    // since this is used on input field, if a user types a country name, we need to check
    // if it is in the allCountries array first otherwise it will always return false
    const isCountry = allCountries.some((country) => country.label === countryName);
    if (!isCountry) return true;
    return supportedCountries.some((country) => country.label === countryName);
  }

  return { supportedCountries, allCountries, isCountrySupported };
}
